import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtSectionTitle from "../general/NtSectionTitle";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";

function NtTelehealthServiceSection({}) {
  const renderBox = (icon, title, containerStyle) => {
    return (
      <View
        style={[
          {
            borderWidth: 1,
            borderColor: "#2c4d7a",
            backgroundColor: "#050f1d",
            borderRadius: 15,
            alignItems: "center",
            padding: 30,
          },
          containerStyle,
        ]}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <NtMaterialIcon name={icon} size={34} color="#006AFF" />
        </View>
        <NtText
          style={{
            color: "white",
            fontSize: 14,
            fontWeight: "600",
            marginTop: 15,
            textAlign: "center",
          }}
        >
          {title}
        </NtText>
      </View>
    );
  };

  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/8b829285038deadeb5bb2192b60b5a325772ace1.jpg")}
    >
      <View
        style={{
          width: "100%",
          marginTop: 20,
        }}
      >
        <NtSectionTitle style={{ textAlign: "left" }}>
          OTHER INCLUDED SERVICES
        </NtSectionTitle>

        <View style={{ flexDirection: "row", marginTop: 15 }}>
          {renderBox("sign-direction", "Wayfinding\nServices", {
            marginRight: 10,
            flex: 1,
          })}
          {renderBox("message", "Messaging\nServices", {
            marginRight: 10,
            flex: 1,
          })}
          {renderBox("map-marker", "Location\nServices", {
            marginRight: 10,
            flex: 1,
          })}
          {renderBox("map-legend", "Heat Maps\n ", { flex: 1 })}
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    height: 280,
  },
});

export default NtTelehealthServiceSection;
